import { render } from "./addpurchase.vue?vue&type=template&id=3a0eb9dc&scoped=true"
import script from "./addpurchase.vue?vue&type=script&lang=js"
export * from "./addpurchase.vue?vue&type=script&lang=js"

import "./addpurchase.vue?vue&type=style&index=0&id=3a0eb9dc&scoped=true&lang=css"
import "./addpurchase.vue?vue&type=style&index=1&id=3a0eb9dc&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0eb9dc"]])

export default __exports__